import validate from 'validate.js'

const constraints = {
  userStudentId: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
